export default "__VITE_ASSET__DTKoqvG5__"